// 공지사항 상세 뷰 컴포넌트
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { useLanguage } from '@/contexts/AppContext';
import { AnnouncementHeader } from './AnnouncementHeader';
import { getTypeIcon, getTypeColor, formatAnnouncementDate } from './utils';
import type { Announcement, AnnouncementTranslations } from './types';

interface AnnouncementDetailViewProps {
  announcement: Announcement;
  translations: AnnouncementTranslations;
  onBack: () => void;
}

export function AnnouncementDetailView({
  announcement,
  translations,
  onBack,
}: AnnouncementDetailViewProps) {
  const { language } = useLanguage();
  return (
    <div
      className="min-h-screen bg-muted"
      style={{ fontFamily: "'Noto Sans', 'Noto Sans KR', sans-serif" }}
    >
      {/* Header */}
      <AnnouncementHeader onBack={onBack} translations={translations} />

      {/* Detail Content */}
      <div className="p-[min(5vw,1.25rem)]">
        <Card className="bg-background border-0 shadow-sm p-[min(5vw,1.25rem)]">
          {/* Type Badge */}
          <Badge className={`${getTypeColor(announcement.type)} mb-[min(3vw,0.75rem)] border`}>
            {getTypeIcon(announcement.type)}
            <span className="ml-[min(1.5vw,0.375rem)]">{translations[announcement.type]}</span>
          </Badge>

          {/* Title */}
          <h2 className="text-[min(5vw,1.25rem)] font-bold text-foreground mb-[min(2vw,0.5rem)]">
            {announcement.title}
          </h2>

          {/* Date */}
          <p className="text-[min(3vw,0.75rem)] text-muted-foreground mb-[min(5vw,1.25rem)]">
            {formatAnnouncementDate(announcement.date, language)}
          </p>

          {/* Divider */}
          <div className="h-[1px] bg-border mb-[min(5vw,1.25rem)]" />

          {/* Content */}
          <div className="text-[min(3.5vw,0.875rem)] text-foreground whitespace-pre-line leading-relaxed">
            {announcement.content}
          </div>
        </Card>
      </div>
    </div>
  );
}
